import { IMapViewPublishedTo } from './MapViewsSidebarListItem'
import { PublishToAppKey } from './PublishToChipRow'

// Merge BASE is LIVE (not session snapshot) so an external update on an untouched key
// survives apply. Only keys the user flipped vs session snapshot are written back.
export const mergePublishToDraft = (args: {
  live: IMapViewPublishedTo
  snapshot: IMapViewPublishedTo
  availableApps: PublishToAppKey[]
  draft: ReadonlySet<string>
}): IMapViewPublishedTo => {
  const { live, snapshot, availableApps, draft } = args
  const next: IMapViewPublishedTo = { ...live }
  for (const key of availableApps) {
    const wasChecked = snapshot[key]
    const isChecked = draft.has(key)
    if (wasChecked !== isChecked) {
      next[key] = isChecked
    }
  }
  return next
}
